import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Col, Modal, Row } from 'react-bootstrap';
import Lottie from 'lottie-react';
import confirmEmailLight from 'assets/img/animated-icons/coming-soon-light.json';
import confirmEmailDark from 'assets/img/animated-icons/coming-soon-dark.json';
import { useAppContext } from 'providers/AppProvider';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMailForward, faSignIn } from '@fortawesome/free-solid-svg-icons';
import authenticationService from 'services/authentication';
import NPSpinner from 'components/base/NPSpinner';

const ConfirmEmail = () => {
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();
  const {
    config: { theme }
  } = useAppContext();
  const [confirmationStatus, setConfirmationStatus] = useState<string | null>(
    null
  );
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const emailParam = query.get('email');
    const tokenParam = query.get('token');

    // Check if emailParam and tokenParam are not null before decoding
    const q_email = emailParam !== null ? decodeURIComponent(emailParam) : '';
    const q_token = tokenParam !== null ? decodeURIComponent(tokenParam) : '';

    // Call the API
    authenticationService
      .confirmEmail(q_email, q_token)
      .then(response => {
        // Check the response status
        if (response == 'Email confirmed successfully') {
          setConfirmationStatus('confirmed');
          setIsLoading(false);
        } else {
          throw new Error('Client error');
        }
      })
      .catch(() => {
        // Handle the error here
        setConfirmationStatus('confirmation_error');
        setIsLoading(false);
      });
  }, []);
  const handleResendConfirmation = () => {
    // Get the email from the query string
    const query = new URLSearchParams(location.search);
    const q_email = query.get('email');
    // Resend confirmation email
    authenticationService
      .resendConfirmationEmail(q_email || '')
      .then(() => {
        // Notify the user that a new confirmation email has been sent
        //('New confirmation email sent. Please check your inbox.');
      })
      .catch((error: unknown) => {
        console.error('Resend Confirmation Error:', error);
      });
  };
  if (isLoading) {
    return <NPSpinner />;
  }
  return (
    <Row className="flex-center content-min-h pb-9">
      <Col xs={12} xxl={10}>
        <Row className="align-items-xl-center g-2">
          <Col xs={12} xl={6} className="order-xl-1">
            <div className="d-flex flex-center">
              <Lottie
                animationData={
                  theme === 'light' ? confirmEmailLight : confirmEmailDark
                }
                loop={true}
                className="w-xl-100 animation"
              />
            </div>
          </Col>
          <Col xs={12} xl={6}>
            <div>
              {confirmationStatus === 'confirmed' ? (
                <div className="d-flex justify-content-center mt-xl-15">
                  <div className="text-container text-center text-xl-start">
                    <h2 className="text-gray-800 fs-xl-6 mb-3">
                      Your registration is complete!
                    </h2>
                    <p className="mb-6 w-xxl-75">
                      <b>Alright!</b> Let's get started!
                    </p>
                    <Row className="g-3 w-md-75 w-xl-100 w-xxl-75 mx-auto mx-xl-0">
                      <Col xs="auto" className="pe-0">
                        <Button
                          as={Link}
                          to="/pages/authentication/split/sign-in"
                          variant="primary"
                          endIcon={
                            <FontAwesomeIcon
                              icon={faSignIn}
                              className="fs-10"
                            />
                          }
                        >
                          Sign in
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                <div>
                  <p>
                    Your email confirmation has expired or encountered an issue.
                  </p>
                  <Button
                    variant="primary"
                    endIcon={
                      <FontAwesomeIcon icon={faMailForward} className="fs-10" />
                    }
                    onClick={() => {
                      handleResendConfirmation();
                      setModalShow(true);
                    }}
                  >
                    Resend Confirmation Email
                  </Button>

                  <Modal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                        Ping!
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h4>New confirmation on its way to you!</h4>
                      <p>
                        We've sent you a new confirmation email. Please check
                        your inbox. If you don't see it, please check your spam
                        folder.
                      </p>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button onClick={() => setModalShow(false)}>Close</Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ConfirmEmail;
